
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/components/ui/use-toast';

export function useRealtimeFlights() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  useEffect(() => {
    // Subscribe to real-time flight updates
    const channel = supabase
      .channel('realtime-flights')
      .on(
        'postgres_changes',
        {
          event: '*', // Listen to all events (INSERT, UPDATE, DELETE)
          schema: 'public',
          table: 'flights'
        },
        (payload) => {
          console.log('Real-time flight change:', payload);
          
          // Invalidate and refetch flights data to update the UI
          queryClient.invalidateQueries({ queryKey: ['flights'] });
          
          // Show notification for updates (not inserts to avoid spam)
          if (payload.eventType === 'UPDATE') {
            const flight = payload.new as any;
            toast({
              title: "Flight Updated",
              description: `${flight.flight_number} status has been updated`,
            });
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient, toast]);
}
